export default "__VITE_ASSET__CkuFKbdI__"